import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { mappingResultError, Result, UseCase } from '@digibricks/core';
import { SectionStatus } from '../../../../core';
export var SAVE_SECTION_USE_CASE = 'SAVE_SECTION_USE_CASE';
export var SaveSectionUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(SaveSectionUseCase, _UseCase);

  var _super = _createSuper(SaveSectionUseCase);

  function SaveSectionUseCase(formRepository) {
    var _this;

    _classCallCheck(this, SaveSectionUseCase);

    _this = _super.call(this);
    _this.formRepository = formRepository;
    return _this;
  }

  _createClass(SaveSectionUseCase, [{
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(useCaseInput) {
        var section, _useCaseInput$isSkipA, isSkipApiCall, resultOrError;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                section = useCaseInput.section, _useCaseInput$isSkipA = useCaseInput.isSkipApiCall, isSkipApiCall = _useCaseInput$isSkipA === void 0 ? false : _useCaseInput$isSkipA;

                if (!isSkipApiCall) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", Result.ok(section));

              case 3:
                if (!(section.status === SectionStatus.New)) {
                  _context.next = 11;
                  break;
                }

                _context.next = 6;
                return this.formRepository.createSection(section);

              case 6:
                resultOrError = _context.sent;

                if (!resultOrError.isFailure) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return", mappingResultError(resultOrError));

              case 9:
                section.updateStatus(SectionStatus.Activate);
                return _context.abrupt("return", Result.ok(section));

              case 11:
                _context.next = 13;
                return this.formRepository.updateSection(section);

              case 13:
                return _context.abrupt("return", _context.sent);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return SaveSectionUseCase;
}(UseCase);